import { MOUNT_POINTS, SELECTORS, } from '../../jsCore/config/preRenderedSelectorsConfig';
import { classList, node, createElement, } from '../../jsCore/utils/dom';


const { POST_BODY_WRAP_SELECTOR, } = SELECTORS;
const INJECTION_CONF = {
  TAG_NAME: 'div',
  PARENT_NODE: POST_BODY_WRAP_SELECTOR,
  CLASS_NAME: MOUNT_POINTS.FACEBOOK_BOT_MOUNT_POINT.slice(1),
};


export function injectFacebookBotInsideArticle(){
  const { TAG_NAME, PARENT_NODE, CLASS_NAME, } = INJECTION_CONF;
  const injectedNode = createElement(TAG_NAME);
  classList(injectedNode).add(CLASS_NAME);
  const parentNode = node(PARENT_NODE);
  parentNode.insertBefore(injectedNode, parentNode.childNodes[0]);
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/facebook_bot/facebookBotNodeInjector.js